import React, { useState, useEffect } from 'react'
import { View, ScrollView } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { StackNavigationProp } from '@react-navigation/stack'
import tw from 'tailwind-rn'
import { useDispatch } from 'react-redux'

import ActionCreators from '../../store/actions'
import { RootStackParamList } from '../../navigators/AppNavigator'
import { HGView, HGHeading } from '../../components/HGUI'
import { BlockGrid } from '../../components/Content'
import { ResourceType } from '../../config/types'

type Props = {
  navigation: StackNavigationProp<RootStackParamList, 'StartOverviewChildren'>
}

const StartOverviewChildrenScreen = (props: Props) => {
  const { navigation } = props
  const [resource, setResource] = useState<ResourceType | null>(null)
  const dispatch = useDispatch()

  const loadStartChildrenOverviewResource = async () => {
    try {
      const result = await dispatch(
        ActionCreators.loadResource({ resourceId: '44' })
      )

      if (result?.title) {
        navigation.setOptions({ title: result.title })
      }
      setResource(result)
    } catch (e) {
      dispatch(ActionCreators.handleError(e))
    }
  }

  useEffect(() => {
    loadStartChildrenOverviewResource()
  }, [])

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <ScrollView style={tw('px-3')}>
        <HGView>
          <HGHeading>Kinder</HGHeading>

          <BlockGrid blocks={resource?.blocks || null} />
        </HGView>
      </ScrollView>
    </SafeAreaView>
  )
}

export default StartOverviewChildrenScreen
